var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulbHalogenCrackedDisabledLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 119.03V112h7.03L56 119.03zm28-28V43.656l9.211 9.211-5 11 6.183 6.183-5.699 16.283 13.04-13.04 1.871-5.345-5.817-5.817 5-11L91.657 40H108v27.03l8-8V39.38c0-6.635-4.415-8.045-6.786-8.803a17.401 17.401 0 0 1-1.358-.473c-1.904-.79-2.478-1.028-3.661-4.233-.358-.968-.608-1.876-.85-2.755C102.61 20.455 101.384 16 96 16s-6.611 4.455-7.345 7.116c-.242.879-.492 1.787-.85 2.757-1.183 3.203-1.757 3.441-3.661 4.231-.414.172-.873.318-1.358.473C80.415 31.335 76 32.745 76 39.38v59.65l8-8zm31.985 11.028c.01-.117.015-.234.015-.35V92.97l-8 8v.56L107.08 112H100v-3.03L88.97 120H112v8H80.97l-8 8H76v24h8v-24h24v24h8v-24h4v-16h16v-8h-20.89l.875-9.942zm58.844-79.23l-5.658-5.657-152 152 5.658 5.658 152-152z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbHalogenCrackedDisabledLight);
export default __webpack_public_path__ + "static/media/lightbulb-halogen-cracked-disabled-light.24172a0dadc9eba752dc296dc97b2f82.svg";
export { ForwardRef as ReactComponent };